import { render, staticRenderFns } from "./ChannelView.vue?vue&type=template&id=3b3e87fc&"
import script from "./ChannelView.vue?vue&type=script&lang=js&"
export * from "./ChannelView.vue?vue&type=script&lang=js&"
import style0 from "./ChannelView.vue?vue&type=style&index=0&id=3b3e87fc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports